export const SkeletonCards = ({ count = 3 }: { count?: number }) => {
  return (
    <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-3">
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="panel p-4">
          <div className="flex items-center gap-3">
            <div className="skeleton h-11 w-11 rounded-full" />
            <div className="min-w-0 flex-1 space-y-2">
              <div className="skeleton h-4 w-2/3" />
              <div className="skeleton h-3 w-1/3" />
            </div>
            <div className="skeleton h-6 w-16 rounded-full" />
          </div>
          <div className="mt-4 space-y-2">
            <div className="skeleton h-3 w-full" />
            <div className="skeleton h-3 w-4/5" />
          </div>
          <div className="mt-4 skeleton h-11 w-full rounded-xl" />
        </div>
      ))}
    </div>
  );
};
